import gql from 'graphql-tag';

import { executeGqlQuery } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type {
  BackendProjectConnection,
  BackendQueryAssociatedProjectsArgs,
} from 'src/types/backend';

import { PROJECT_FROM_LIST_FRAGMENT } from './schema';

const QUERY = gql`
  query AssociatedProjects(
    $customerId: ID!
    $workspaceId: ID!
    $filter: JSON!
    $cursor: String
    $withAssetsGenerationTools: Boolean = false
  ) {
    associatedProjects(
      customerId: $customerId
      workspaceId: $workspaceId
      filter: $filter
      first: 12
      after: $cursor
    ) {
      edges {
        node {
          ...ProjectFromList
          assetsGenerationTools @include(if: $withAssetsGenerationTools)
        }
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
  }
  ${PROJECT_FROM_LIST_FRAGMENT}
`;

type Variables = Pick<BackendQueryAssociatedProjectsArgs, 'customerId' | 'workspaceId'> & {
  cursor?: string;
  filter: Record<string, unknown>;
};
type Result = BackendProjectConnection;

export const queryAssociatedProjects = async ({
  customerId,
  workspaceId,
  cursor,
  filter,
}: Variables) => {
  const result = await executeGqlQuery({
    query: QUERY,
    variables: {
      customerId,
      workspaceId,
      filter: JSON.stringify(filter),
      cursor,
    },
  });
  return getSingleProp<Result>(result.data);
};
